import { Link } from "react-router-dom";
import { Home, ArrowRight, Waves } from "lucide-react";
import { useSeo } from "@/lib/useSeo";

export default function NotFound() {
  useSeo({ title: "Page Not Found | BIOSYN", description: "The page you are looking for could not be found." });
  return (
    <div className="min-h-[70vh] flex items-center justify-center" style={{ background: "#F5FAFC" }}>
      <div className="text-center px-6">
        <Waves className="w-14 h-14 mx-auto mb-6" style={{ color: "#16B8D4" }} />
        <p className="font-heading text-7xl md:text-8xl font-extrabold" style={{ color: "#063B63" }}>404</p>
        <h1 className="mt-3 font-heading text-2xl font-bold" style={{ color: "#063B63" }}>Page not found</h1>
        <p className="mt-2 text-sm" style={{ color: "#4A6B82" }}>The page you're looking for may have drifted away with the current.</p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" data-testid="notfound-home" className="btn-primary"><Home className="w-4 h-4" /> Back to Home</Link>
          <Link to="/products" data-testid="notfound-products" className="btn-outline-blue">Explore Products <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </div>
    </div>
  );
}
